import axios from "axios";
import { ApiLink } from "../../../APILink/ApiLink";
import authHeader from "../../../Auth/authHeader";
import { describeImportRequestError } from "../articleImportErrors";
import { partnerName } from "./partnerImportModel";

async function fetchList(endpoint, label, params) {
  let response;
  try { response = await axios.get(`${ApiLink.API_URL}${endpoint}`, { headers: authHeader(), timeout: 60000, ...(params ? { params } : {}) }); }
  catch (error) { throw new Error(describeImportRequestError(error, label)); }
  if (!Array.isArray(response.data)) throw new Error(`${label}: serveri ktheu format të pavlefshëm.`);
  return response.data;
}

export async function fetchPartnerImportLookups() {
  const allStates = await fetchList("states", "Shtetet");
  const states = allStates.filter(item => ["kosove", "kosova", "kosovo"].includes(partnerName(item.StateName).normalize("NFD").replace(/[\u0300-\u036f]/g, "")));
  if (states.length !== 1 || !Number.isInteger(Number(states[0].StateID)) || Number(states[0].StateID) <= 0)
    throw new Error("Kosova nuk u identifikua në mënyrë unike në listën e shteteve të Accountree.");
  const stateId = Number(states[0].StateID);
  const [cityRows, banks] = await Promise.all([
    fetchList("Cities/getcitybystate", "Qytetet e Kosovës", { stateid: stateId }),
    fetchList("LicencedBanks", "Bankat"),
  ]);
  return { states, cities: cityRows.filter(item => Number(item.StateID) === stateId), banks };
}
